import useApplyVideoObjectFit from '@hooks/ref/useApplyVideoObjectFit';
import type { BaseComponentProps } from '@interfaces/selection';
import { useAudioVideo } from '@providers/AudioVideoProvider';
import type { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { useEffect, useRef } from 'react';
import { Container } from './style';

interface PeerVideoProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'css'>, BaseComponentProps {
  /** The tile ID to bind the video element to */
  tileId: number;
  /** The name to show on the video's nameplate */
  name?: string;

  attendeeId: string;
}

const PeerVideo: FC<PropsWithChildren<PeerVideoProps>> = ({
  name,
  tileId,
  attendeeId,
  ...rest
}) => {
  const audioVideo = useAudioVideo();
  const videoEl = useRef<HTMLVideoElement | null>(null);
  useApplyVideoObjectFit(videoEl);

  useEffect(() => {
    if (!audioVideo || !videoEl.current) {
      return;
    }

    audioVideo.bindVideoElement(tileId, videoEl.current!);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);
      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId]);

  return (
    <Container
      {...rest}
      ref={videoEl}
      nameplate={name}
      attendeeId={attendeeId}
      videoTileType={'peer'}
    />
  );
};

export default PeerVideo;
